import React from 'react'
import { Form } from 'semantic-ui-react'

export default class NoteField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.TextArea
        label="Note"
        placeholder="e.g Call to manager if necessary..."
        onChange={e => onChange('note', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/noteField.js